import { initTacos as initTacosCodes } from "@onestore/tacos"
import { CM_VENDOR_1AND1, CM_VENDOR_BRAND } from "./consentManager"

export function initTacos() {
  const cmp = window.__cmp("getCMPData")

  const externalReferrersDisableListText =
    process.env.GATSBY_TACOS_EXTERNAL_REFERRERS_DISABLE_LIST

  const externalReferrersDisableList = externalReferrersDisableListText
    ? externalReferrersDisableListText
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
    : []

  initTacosCodes({
    apiUrl: process.env.GATSBY_TACOS_API_URL,
    domain: process.env.GATSBY_STORE_DOMAIN,
    marketLocale: process.env.GATSBY_TACOS_MARKET,
    canWriteCookies: !!cmp.vendorConsents[CM_VENDOR_1AND1],
    canWriteStorage: !!cmp.vendorConsents[CM_VENDOR_BRAND],
    externalReferrersHostsDisableList: externalReferrersDisableList,
  })
}
